<template>
  <div id="aboutUs">
    <div class="wrapper">
        <div class="backDecor">
  <svg width="62" height="31" viewBox="0 0 62 31" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon1'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M62 31C62 13.88 48.12 0 31 0 13.88 0 0 13.88 0 31h62z" fill="#DED3FF"/></svg>
  <svg width="38" height="77" viewBox="0 0 38 77" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon2'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 77c20.987 0 38-17.237 38-38.5S20.987 0 0 0v77z" fill="#5F2EEA"/></svg>
  <svg width="38" height="77" viewBox="0 0 38 77" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 77c20.987 0 38-17.237 38-38.5S20.987 0 0 0v77z" fill="#fff"/></svg>
  <svg width="62" height="31" viewBox="0 0 62 31" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon4'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M62 31C62 13.88 48.12 0 31 0 13.88 0 0 13.88 0 31h62z" fill="#DED3FF"/></svg>
  </div>
  <div class="textContainer">
  <div class="textWrapper">
    <div class="wrappertext">
    <h2>О нас</h2>
    <p>Все функции нашего сервиса для вас полностью бесплатны. 
    Не тратьте время на сбор необходимых документов, походы по банкам и кредитным организациям! С помощью Нужна<span>Кредитка!</span>
    вы можете получить карту не выходя из дома, любым удобным для вас способом. Самые выгодные предложения, онлайн-консультирование,  
    помощь в получении кредитных карт и разрешении финансовых проблем – все к вашим услугам!</p>
  </div>
  </div>
  <img class="imgwoman" src="@/assets/img/womanPNG.png">
</div>
  </div>
 
  
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
}
</script>

<style scoped>
#aboutUs{ background-color: rgba(249, 250, 252, 1);}
.textWrapper{padding:15vw 13vw;position: relative; padding-bottom: 0vw;}
h2{padding-bottom: 6vw;}
span{color: #5F2EEA;}
.backDecor{position: relative;height: 0;width: 100%;}
.backDecor svg{position: absolute;}
.icon1{top: 0vw; left: 65vw;}
.icon2{top: 91vw;left: 0vw;}
.icon3{top: 91vw;left: 18vw;}
.icon4{top: 120vw;left: 21vw;}
.imgwoman{position: relative; width: 100%;height: 100%; bottom: -2vw;}

 
 @media screen and (min-width: 760px) {
   .icon1{width: 120px; height: 60px;}
.icon2{width: 120px; height: 190px;}
.icon3{width: 120px; height: 190px;}
.icon4{width: 120px; height: 190px;}
 }

  @media screen and (min-width: 1140px) {
.textContainer{display: flex;flex-direction:row-reverse;padding-top: 40px;}
.textWrapper{padding:15px; width: 939px;padding-right: 83px;}
h2{font-size: 34px; padding-bottom: 23px;}
p{font-size: 18px;}
.wrappertext{padding-top: 30px;}
.imgwoman{width: 80%;;height: 100%;}

.icon1{top: 0px;left: 1010px;}
.icon2{top: -130px; left: 0px;}
.icon3{top: -130px;left: 120px;}
.icon4{top: 68px; left: 68px; }
#aboutUs{overflow: hidden; }
 }



</style>
